import { Component, OnInit } from '@angular/core';
import { LoginService} from '../../services/login.service';
import { AuthService} from '../../services/auth.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  isChecked: boolean = false;
  user = { 
    login: "",
    password: ""
  };

  newUser = { 
    login: "",
    password: "",
    passwordAgain: "",
    email: ""
  };

  constructor(private loginService: LoginService, private authService: AuthService) { }

  ngOnInit() {
    if(localStorage.getItem("isLogged") == "Of course! :)"){
      this.authService.redirectToHome();
    }
  }

  chooseLogin(){
    this.loginService.errorText = "";
    this.loginService.choosedLogin = true; 
  }

  chooseRegistration(){
    this.loginService.errorText = "";
    this.loginService.choosedLogin = false; 
  }

  userLogin(){
    this.loginService.successText = "";
    this.loginService.getUser(this.user);
  }
  userRegistration(){
    let emailReg = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

    if(this.newUser.login.length < 5){
      this.loginService.errorText = "Login musí mít alespoň pět znaků.";
    }
    else if(this.newUser.password.length < 7){
      this.loginService.errorText = "Heslo musí mít alespoň sedm znaků.";
      this.newUser.password = "";
      this.newUser.passwordAgain = "";
    }
    else if(this.newUser.password != this.newUser.passwordAgain){
      this.loginService.errorText = "Kontrolní heslo se neshoduje se zadaným heslem.";
      this.newUser.password = "";
      this.newUser.passwordAgain = "";
    }  
    else if(emailReg.test(this.newUser.email) == false){
      this.loginService.errorText = "Email nebyl zadán správně.";
    }
    else{
      this.loginService.addUser(this.newUser);
    }
    
  }
}



// WEBPACK FOOTER //
// ./src/app/components/login/login.component.ts